import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app_setting_gen_2 from '@devices/settings/device_settings/app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2 from '@devices/settings/device_settings/settings_gen_2.js';
import { sensor_addon } from '@devices/settings/device_settings/addon_sensors';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPlusUni',
	friendly_name: 'Plus Uni',
	family: 'relay',
	isPM: false,
	addons: sensor_addon,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 2,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				{
					title: 'peripherals',
					components: [{ title: 'addon_enable', component: 'addon_enable' }],
				},
				{
					title: 'plus_uni_counter',
					components: [
						{
							title: 'plus_uni_counter_settings',
							component: 'plus_uni_counter',
						},
					],
				},
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				app_setting_gen_2,
				share,
				settings_gen_2,
			],
		},
	},
};
